"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const ol = __importStar(require("ol"));
const render_1 = require("ol/render");
const extent_1 = require("ol/extent");
const proj_1 = require("ol/proj");
const MapLayer_1 = __importDefault(require("./models/MapLayer"));
const WKT_1 = __importDefault(require("ol/format/WKT"));
const Vector_1 = __importDefault(require("ol/layer/Vector"));
const Vector_2 = __importDefault(require("ol/source/Vector"));
const Fill_1 = __importDefault(require("ol/style/Fill"));
const Stroke_1 = __importDefault(require("ol/style/Stroke"));
const Style_1 = __importDefault(require("ol/style/Style"));
const Center_1 = __importDefault(require("../Results/MapOlLocal/Modules/Models/Center"));
const Point_1 = __importDefault(require("ol/geom/Point"));
const style_1 = require("ol/style");
const Overlay_1 = __importDefault(require("ol/Overlay"));
const ColorLibController_1 = __importDefault(require("../Results/Abstract/Controllers/ColorLibController"));
const Polygon_1 = __importDefault(require("ol/geom/Polygon"));
const WebGLTile_js_1 = __importDefault(require("ol/layer/WebGLTile.js"));
const GeoTIFF_1 = __importDefault(require("ol/source/GeoTIFF"));
const geom_1 = require("ol/geom");
const Draw_js_1 = __importDefault(require("ol/interaction/Draw.js"));
const StylesGenerator_1 = __importDefault(require("./utils/StylesGenerator"));
const Modify_js_1 = __importDefault(require("ol/interaction/Modify.js"));
const trans_1 = require("@common/tsutils/trans");
const olSphere = __importStar(require("ol/sphere"));
class MapBmkController {
    constructor(mapLayer = new MapLayer_1.default(), mapId = 'bmfw-map-bmk', btnPointPopup = 'bmfw-tooltip-btn', pointPopup = 'bmfw-tooltip', tooltipPolygonButtonId = '', polygonConnectorId = '', tiff = '') {
        this.hfeaturePolygon = null;
        this.tooltip = null;
        this.previusUrlRaster = '';
        this.statesRaterNames = [];
        this.map = new ol.Map();
        this.dataProj = 'EPSG:4326';
        this.featureProj = 'EPSG:3857';
        this.centerCoordinates = [-10018754.171394622, 4685281.0516434];
        this.initZoom = 16;
        this.maxZoom = 18;
        this.minZoom = 0;
        this.mapLayer = mapLayer || new MapLayer_1.default();
        this.StylesGenerator = new StylesGenerator_1.default();
        this.pointInfo = '';
        this.parcel = '';
        this.colorController = new ColorLibController_1.default();
        this.mapId = mapId;
        this.btnPointPopup = btnPointPopup;
        this.pointPopup = pointPopup;
        this.dimension = 'area';
        this.parcelFill = '';
        this.parcelStroke = '';
        this.points = [];
        this.isHLTPoint = false;
        this.polygonInfo = '';
        this.tiff = tiff;
        this.tooltipPolygonButtonId = tooltipPolygonButtonId || '';
        this.polygonConnectorId = polygonConnectorId || '';
        this.typeMetric = '';
        this.drawInteraction = null;
        this.modifyInteraction = null;
        this.drawPolygonFeature = null;
        this.lowResolutionExtent = [];
        this.finishDrawInteraction = false;
        this.isErrorSearchZone = false;
        this.errorMenssage = '';
        this.loadingSearchZone = false;
        this.isLoadingMap = false;
        this.intersectingExtentIndices = [];
        this.regionSearch = '';
        this.fieldsWithSamples = [];
        this.areaName = '';
        this.recommendationPolygonName = '';
    }
    get mapLoading() {
        return this.isLoadingMap;
    }
    create() {
        this.draw();
        this.hideControls();
        this.deployTooltipPoint();
        this.deployTooltipPolygon();
        this.hoverEffect();
        const map = this.map;
        map.on('loadstart', () => {
            this.isLoadingMap = true;
            map.getTargetElement().classList.add('spinner');
        });
        map.on('loadend', () => {
            this.isLoadingMap = false;
            map.getTargetElement().classList.remove('spinner');
        });
    }
    updateTiffUrl(newUrl) {
        this.tiff = newUrl;
        this.onGeotiffLoaded();
    }
    draw() {
        this.map = new ol.Map({
            target: this.mapId,
            layers: this.mapLayer.layers,
            view: this.view,
        });
    }
    get view() {
        return new ol.View({
            zoom: this.initZoom,
            center: this.centerCoordinates,
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
        });
    }
    get projections() {
        return { dataProjection: this.dataProj, featureProjection: this.featureProj };
    }
    hideControls() {
        const controls = this.map.getControls();
        controls.forEach((control) => {
            control.setMap(null);
        });
    }
    setAreaName(areaName) {
        this.areaName = areaName;
    }
    polygonStyle(fillColor, strokeColor) {
        return new Style_1.default({
            fill: new Fill_1.default({
                color: fillColor,
            }),
            stroke: new Stroke_1.default({
                color: strokeColor,
                width: 5,
            }),
        });
        /*  var style = new Style({
            fill: new Fill({
                color: 'transparent',
            }),
            stroke: new Stroke({
                color: '#eebb54',
                width: 5,
            }),
        });

        var img = new Image();
        img.src = '/images/map/parcels/bg.svg';

        img.onload = function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var pattern;

            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            pattern = ctx.createPattern(canvas, 'repeat');

            style.setFill(
                new Fill({
                    color: pattern,
                })
            );
        };

        return style; */
    }
    updateTypeMetric(type) {
        this.typeMetric = type;
    }
    pointStyle(point, isHLT) {
        var _a;
        return new Style_1.default({
            image: new style_1.Icon({
                anchor: [10, 50],
                anchorXUnits: 'pixels',
                anchorYUnits: 'pixels',
                src: '/images/map/resources/tube-icon.svg',
                color: point.info.level !== undefined ? this.generateColorRank((_a = point.info) === null || _a === void 0 ? void 0 : _a.level, this.typeMetric === 'HLT') : '#282b25',
            }),
            zIndex: 0,
        });
        /* } else {
            return new Style({
                image: new Icon({
                    anchor: [10, 50],
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    src: '/images/map/resources/tube-icon.svg',
                }),
                zIndex: 0,
            });
        } */
    }
    deleteLayer(layerId) {
        const layers = this.map.getLayers().getArray();
        const layersToDelete = layers.filter((layer) => layer.get('id') === layerId);
        layersToDelete.forEach((layer) => {
            this.map.removeLayer(layer);
        });
    }
    addLayer(layer) {
        this.map.addLayer(layer);
    }
    generateColorRank(value, isHLT) {
        if (value && this.typeMetric !== 'HLT') {
            return this.colorController.getRankColor(value.toString());
        }
        else if (value && this.typeMetric) {
            return this.colorController.getDiseasesColor(value.toString());
        }
        return this.colorController.getRankColor('0');
    }
    generateColor(value, isHLT) {
        if (value && this.typeMetric !== 'HLT') {
            return this.colorController.getRankColor(this.colorController.getRankFromScore(value).toString());
        }
        else if (value && this.typeMetric === 'HLT') {
            return this.colorController.getDiseasesColor(this.colorController.getRankFromScore(value).toString());
        }
        return this.colorController.getRankColor('0');
    }
    center(parcel, extent, notFly) {
        const config = {
            map: this.map,
            extent: extent,
            multiPolygon: parcel,
            projection: this.projections,
            notFly: notFly,
        };
        const model = new Center_1.default(config);
        model.center();
        this.map = model.map;
    }
    changePolygonStyle(color, stroke) {
        if (this.dimension === 'block' || this.dimension === 'sample') {
            this.divideMultipolygon();
        }
        else {
            const newStyle = this.polygonStyle(color, stroke);
            this.map.getLayers().forEach((layer) => {
                const id = layer.get('id');
                if (id === 'polygon-layer' && layer instanceof Vector_1.default) {
                    const features = layer.getSource().getFeatures();
                    features.forEach((feature) => {
                        feature.setStyle(newStyle);
                    });
                }
            });
        }
    }
    drawPoints(points, isHLT) {
        const popupContainer = document.getElementById(this.pointPopup);
        if (popupContainer)
            popupContainer.style.display = 'none';
        this.deleteLayer('point-layer');
        const source = new Vector_2.default();
        const layer = new Vector_1.default({
            source: source,
        });
        layer.setZIndex(9999);
        layer.set('id', 'point-layer');
        points.forEach((point) => {
            const coordinates = point.coordinates.split(' ');
            const lon = parseFloat(coordinates[0].substring(6));
            const lat = parseFloat(coordinates[1].slice(0, -1));
            const newLon = lon;
            const newLat = lat;
            const feature = new ol.Feature({
                geometry: new Point_1.default((0, proj_1.fromLonLat)([newLon, newLat])),
                pointInfo: point.info,
            });
            feature.setStyle(this.pointStyle(point, this.typeMetric === 'HLT'));
            source.addFeature(feature);
        });
        this.points = points;
        this.isHLTPoint = this.typeMetric === 'HLT';
        this.addLayer(layer);
    }
    generatedStyle(polygonFeature) {
        let count = 0;
        let totalLevel = 0;
        const pointsInterPolygon = [];
        this.points.forEach((point) => {
            const coordinates = point.coordinates.split(' ');
            const lon = parseFloat(coordinates[0].substring(6));
            const lat = parseFloat(coordinates[1].slice(0, -1));
            const newLon = lon;
            const newLat = lat;
            const POINT = (0, proj_1.fromLonLat)([newLon, newLat]);
            const pointGeometry = new Point_1.default(POINT);
            if (polygonFeature.getGeometry().intersectsExtent(pointGeometry.getExtent())) {
                // if (point.info.value > 0) { // Pending to confirm with product
                count++;
                // }
                pointsInterPolygon.push(point);
                totalLevel += point.info.value ? point.info.value : 0;
            }
        });
        const averageLevel = count > 1 ? totalLevel / count : totalLevel;
        polygonFeature.set('polygonInfo', {
            count: count,
            averageLevel: averageLevel,
        });
        const color = this.generateColor(averageLevel, false);
        const parcelFill = `${color}30`;
        const parcelStroke = color;
        polygonFeature.setStyle(new Style_1.default({
            fill: new Fill_1.default({
                color: color,
            }),
            stroke: new Stroke_1.default({
                color: [0, 0, 0, 0],
                width: 0,
            }),
        }));
    }
    drawZone(zone, fill, stroke, idZone, calculateStyle = false) {
        const popupContainer = document.getElementById(this.polygonConnectorId);
        if (popupContainer)
            popupContainer.style.display = 'none';
        const feature = new WKT_1.default().readFeature(zone, this.projections);
        const source = new Vector_2.default({ features: [feature] });
        const style = this.polygonStyle(fill, stroke);
        const layer = new Vector_1.default({ source: source, style: style });
        layer.set('id', idZone);
        if (calculateStyle)
            this.generatedStyle(feature);
        this.addLayer(layer);
    }
    drawParcel(parcel, color, stroke) {
        const popupContainer = document.getElementById(this.polygonConnectorId);
        if (popupContainer)
            popupContainer.style.display = 'none';
        this.deleteLayer('polygon-layer');
        this.deleteLayer('homogeneous_zones_layer');
        const feature = new WKT_1.default().readFeature(parcel, this.projections);
        const source = new Vector_2.default({
            features: [feature],
        });
        const layer = new Vector_1.default({
            source: source,
            style: this.polygonStyle(color, stroke),
        });
        layer.set('id', 'polygon-layer');
        this.addLayer(layer);
        if (this.parcel !== parcel) {
            this.center(parcel, [], false);
        }
        this.parcel = parcel;
        this.parcelFill = color;
        this.parcelStroke = stroke;
        if (this.dimension === 'block' || this.dimension === 'sample' || this.dimension === 'hd') {
            this.divideMultipolygon();
        }
        this.getFields();
    }
    tooltipPolygon(popupElement) {
        const popup = new Overlay_1.default({
            element: popupElement,
            positioning: 'bottom-center',
            stopEvent: false,
            offset: [0, -10],
        });
        return popup;
    }
    deployTooltipPolygon() {
        const tooltip = new Overlay_1.default({
            element: document.getElementById(this.polygonConnectorId),
            offset: [0, -10],
            positioning: 'bottom-center',
            stopEvent: false,
        });
        this.map.addOverlay(tooltip);
        this.map.on('click', (event) => {
            const pixel = event.pixel;
            const feature = this.map.forEachFeatureAtPixel(pixel, (feature) => feature);
            const popupElement = tooltip.getElement();
            const isInsidePopup = popupElement && popupElement.contains(event.originalEvent.target);
            if (isInsidePopup) {
                return;
            }
            if (feature &&
                (feature.getGeometry() instanceof Polygon_1.default ||
                    (this.dimension === 'homogenous zones' && feature.getGeometry() instanceof geom_1.MultiPolygon))) {
                // Aquí cambiamos la posición del tooltip a las coordenadas del evento de clic
                tooltip.setPosition(event.coordinate);
                this.polygonSelected = feature.get('polygonInfo');
                this.polygonInfo = feature.get('polygonInfo');
                const button = document.getElementById(this.tooltipPolygonButtonId);
                button.click();
                const popupContainer = document.getElementById(this.polygonConnectorId);
                if (popupContainer) {
                    popupContainer.style.display = 'block';
                }
            }
            else {
                tooltip.setPosition(undefined);
            }
        });
    }
    deployTooltipPoint() {
        const tooltip = new Overlay_1.default({
            element: document.getElementById(this.pointPopup),
            offset: [0, -10],
            positioning: 'bottom-center',
            stopEvent: false,
        });
        this.map.addOverlay(tooltip);
        this.map.on('click', (event) => {
            const feature = this.map.forEachFeatureAtPixel(event.pixel, (feature) => feature);
            const popupElement = tooltip.getElement();
            const isInsidePopup = popupElement && popupElement.contains(event.originalEvent.target);
            if (isInsidePopup) {
                return;
            }
            if (feature && feature.getGeometry() instanceof Point_1.default) {
                const layer = this.map
                    .getLayers()
                    .getArray()
                    .find((layer) => layer.get('id') === 'point-layer');
                if (layer && layer.getSource().getFeatures().includes(feature)) {
                    const coordinates = feature.getGeometry().getCoordinates();
                    this.pointInfo = feature.get('pointInfo');
                    const button = document.getElementById(this.btnPointPopup);
                    if (button) {
                        button.click();
                    }
                    const popupContainer = document.getElementById(this.pointPopup);
                    if (popupContainer) {
                        popupContainer.style.display = 'block';
                    }
                    if (coordinates) {
                        tooltip.setPosition(coordinates);
                    }
                }
            }
            else {
                tooltip.setPosition(undefined);
            }
        });
    }
    zoomIn() {
        const currentZoom = this.map.getView().getZoom();
        const maxZoom = this.map.getView().getMaxZoom();
        if (currentZoom < maxZoom) {
            this.map.getView().setZoom(currentZoom + 1);
        }
    }
    zoomOut() {
        const currentZoom = this.map.getView().getZoom();
        const minZoom = this.map.getView().getMinZoom();
        if (currentZoom > minZoom) {
            this.map.getView().setZoom(currentZoom - 1);
        }
    }
    visibilitySamples(isDeploy) {
        const layers = this.map.getLayers().getArray();
        const layerId = 'point-layer';
        const layer = layers.find((layer) => layer.get('id') === layerId);
        if (isDeploy && layer) {
            layer.setVisible(true);
        }
        else {
            layer.setVisible(false);
            const elements = document.getElementById(this.pointPopup);
            elements.style.display = 'none';
        }
    }
    changeDimension(dimension) {
        this.dimension = dimension;
        if (dimension === 'area' && !!this.parcel) {
            this.deleteLayer('homogeneous_zones_layer');
            this.deleteLayer('tiff-layer');
            this.drawParcel(this.parcel, this.parcelFill, this.parcelStroke.slice(0, 7));
            this.drawPoints(this.points, this.typeMetric === 'HLT');
            this.visibilitySamples(false);
        }
        if (dimension === 'homogenous zones') {
            this.deleteLayer('tiff-layer');
            this.showRecommendations(false);
            this.drawPoints(this.points, this.typeMetric === 'HLT');
            this.visibilitySamples(false);
        }
        if (dimension === 'sample') {
            this.deleteLayer('homogeneous_zones_layer');
            this.deleteLayer('tiff-layer');
            this.divideMultipolygon();
            this.drawPoints(this.points, this.typeMetric === 'HLT');
            this.visibilitySamples(true);
        }
        if (dimension === 'block') {
            this.deleteLayer('homogeneous_zones_layer');
            this.deleteLayer('tiff-layer');
            this.divideMultipolygon();
            this.drawPoints(this.points, this.typeMetric === 'HLT');
            this.visibilitySamples(false);
        }
        if (dimension === 'hd') {
            this.deleteLayer('homogeneous_zones_layer');
            this.deleteLayer('tiff-layer');
            this.drawPoints(this.points, this.typeMetric === 'HLT');
            this.visibilitySamples(false);
            this.onGeotiffLoaded();
        }
    }
    hoverEffect() {
        let previousFeature = null;
        let previousStyle;
        let featurePolygon = null;
        this.map.on('pointermove', (event) => {
            const pixel = event.pixel;
            const feature = this.map.forEachFeatureAtPixel(pixel, (feature) => feature);
            if (featurePolygon) {
                const polygonInfo = featurePolygon.get('polygonInfo');
                const color = this.generateColor(polygonInfo === null || polygonInfo === void 0 ? void 0 : polygonInfo.averageLevel, false);
                const parcelFill = `${color}30`;
                const parcelStroke = color;
                featurePolygon.setStyle(this.polygonStyle(parcelFill, parcelStroke));
            }
            if (this.hfeaturePolygon) {
                const polygonInfo = this.hfeaturePolygon.get('polygonInfo');
                const color = this.generateColor(polygonInfo === null || polygonInfo === void 0 ? void 0 : polygonInfo.averageLevel, false);
                const parcelFill = `${color}30`;
                const parcelStroke = color;
                this.hfeaturePolygon.setStyle(new Style_1.default({
                    fill: new Fill_1.default({
                        color: color,
                    }),
                    stroke: new Stroke_1.default({
                        color: [0, 0, 0, 0],
                        width: 0,
                    }),
                }));
            }
            if (feature && feature.getGeometry() instanceof Point_1.default) {
                const layer = this.map
                    .getLayers()
                    .getArray()
                    .find((layer) => layer.get('id') === 'point-layer');
                if (layer && layer.getSource().getFeatures().includes(feature)) {
                    this.map.getTargetElement().style.cursor = 'pointer';
                    if (previousFeature && previousFeature !== feature) {
                        previousFeature.setStyle(previousStyle);
                    }
                    const style = feature.getStyle();
                    previousStyle = style;
                    if (feature !== previousFeature) {
                        previousFeature = feature;
                    }
                    if (style) {
                        const circleStyle = style.getImage();
                        if (circleStyle && circleStyle.getScale() <= 1.1) {
                            circleStyle.setScale(1.1);
                        }
                        feature.setStyle(style);
                    }
                }
            }
            else if (previousFeature) {
                previousFeature.setStyle(previousStyle);
                let circleStyle;
                if (previousStyle) {
                    circleStyle = previousStyle.getImage();
                }
                if (circleStyle) {
                    circleStyle.setScale(1);
                }
                previousFeature = null;
                previousStyle = null;
                this.map.getTargetElement().style.cursor = '';
            }
            else if (feature && feature.getGeometry() instanceof geom_1.MultiPolygon) {
                if (this.dimension === 'block' || this.dimension === 'sample' || this.dimension === 'homogenous zones') {
                    this.hfeaturePolygon = feature;
                    this.map.getTargetElement().style.cursor = 'pointer';
                    const polygonInfo = feature.get('polygonInfo');
                    const color = this.generateColor(polygonInfo === null || polygonInfo === void 0 ? void 0 : polygonInfo.averageLevel, false);
                    const parcelFill = `${color}60`;
                    const parcelStroke = color;
                    feature.setStyle(new Style_1.default({
                        fill: new Fill_1.default({
                            color: color,
                        }),
                        stroke: new Stroke_1.default({
                            color: [0, 0, 0, 0],
                            width: 0,
                        }),
                    }));
                    const layers = this.map.getLayers().getArray();
                    const layersT = layers.filter((layer) => layer.get('id') === 'homogeneous_zones_layer');
                    layersT.forEach((layer) => {
                        if (layer.getSource().getFeatures().includes(feature)) {
                            layer.setZIndex(20);
                            layer.setOpacity(1);
                        }
                        else {
                            layer.setZIndex(10);
                            layer.setOpacity(0.1);
                        }
                    });
                }
                if (this.dimension === 'homogenous zones') {
                    const pointsLayer = this.map
                        .getLayers()
                        .getArray()
                        .find((layer) => layer.get('id') === 'point-layer');
                    if (pointsLayer) {
                        const pointsSource = pointsLayer.getSource();
                        const pointsFeatures = pointsSource.getFeatures();
                        pointsFeatures.forEach((pointFeature) => {
                            if (!feature.getGeometry().intersectsCoordinate(pointFeature.getGeometry().getCoordinates())) {
                                pointFeature.setStyle(new Style_1.default({
                                    opacity: 0,
                                    display: 'none',
                                }));
                            }
                            else {
                                const pointInfo = pointFeature.get('pointInfo');
                                const style = new Style_1.default({
                                    image: new style_1.Icon({
                                        anchor: [10, 50],
                                        anchorXUnits: 'pixels',
                                        anchorYUnits: 'pixels',
                                        src: '/images/map/resources/tube-icon.svg',
                                        color: pointInfo.level !== undefined
                                            ? this.generateColorRank(pointInfo.level, this.typeMetric === 'HLT')
                                            : '#282b25',
                                    }),
                                    zIndex: 0,
                                });
                                pointFeature.setStyle(style);
                            }
                        });
                    }
                }
            }
            else if (feature && feature.getGeometry() instanceof Polygon_1.default) {
                if (this.dimension === 'block' || this.dimension === 'sample' || this.dimension === 'homogenous zones') {
                    featurePolygon = feature;
                    this.map.getTargetElement().style.cursor = 'pointer';
                    const polygonInfo = feature.get('polygonInfo');
                    const color = this.generateColor(polygonInfo === null || polygonInfo === void 0 ? void 0 : polygonInfo.averageLevel, false);
                    const parcelFill = `${color}70`;
                    const parcelStroke = '#fff';
                    feature.setStyle(this.polygonStyle(parcelFill, parcelStroke));
                }
            }
            else {
                this.map.getTargetElement().style.cursor = '';
                const layers = this.map.getLayers().getArray();
                const layersT = layers.filter((layer) => layer.get('id') === 'homogeneous_zones_layer');
                layersT.forEach((layer) => {
                    layer.setZIndex(10);
                    layer.setOpacity(1);
                });
                const pointsLayer = this.map
                    .getLayers()
                    .getArray()
                    .find((layer) => layer.get('id') === 'point-layer');
                if (pointsLayer) {
                    const pointsSource = pointsLayer.getSource();
                    const pointsFeatures = pointsSource.getFeatures();
                    pointsFeatures.forEach((pointFeature) => {
                        const pointInfo = pointFeature.get('pointInfo');
                        const style = new Style_1.default({
                            image: new style_1.Icon({
                                anchor: [10, 50],
                                anchorXUnits: 'pixels',
                                anchorYUnits: 'pixels',
                                src: '/images/map/resources/tube-icon.svg',
                                color: pointInfo.level !== undefined
                                    ? this.generateColorRank(pointInfo.level, this.typeMetric === 'HLT')
                                    : '#282b25',
                            }),
                            zIndex: 0,
                        });
                        pointFeature.setStyle(style);
                    });
                }
            }
        });
    }
    divideMultipolygon() {
        const popupContainer = document.getElementById(this.polygonConnectorId);
        if (popupContainer)
            popupContainer.style.display = 'none';
        if (this.dimension === 'block' || this.dimension === 'sample') {
            this.deleteLayer('polygon-layer');
            this.deleteLayer('point-layer');
            const polygonFeatures = [];
            const geometry = new WKT_1.default().readGeometry(this.parcel, this.projections);
            const polygons = geometry.getPolygons();
            this.fieldsWithSamples = [];
            polygons.forEach((polygon, index) => {
                const polygonFeature = new ol.Feature(polygon);
                polygonFeature.setStyle(this.polygonStyle(this.parcelFill, this.parcelStroke));
                let count = 0;
                let totalLevel = 0;
                const pointsInterPolygon = [];
                this.points.forEach((point) => {
                    const coordinates = point.coordinates.split(' ');
                    const lon = parseFloat(coordinates[0].substring(6));
                    const lat = parseFloat(coordinates[1].slice(0, -1));
                    const newLon = lon;
                    const newLat = lat;
                    const POINT = (0, proj_1.fromLonLat)([newLon, newLat]);
                    const pointGeometry = new Point_1.default(POINT);
                    if (polygon.intersectsExtent(pointGeometry.getExtent())) {
                        // if (point.info.value > 0) { // Pending to confirm with product
                        count++;
                        // }
                        pointsInterPolygon.push(point);
                        totalLevel += point.info.value ? point.info.value : 0;
                    }
                });
                const pointCodes = pointsInterPolygon.map((point) => point.info.code);
                const polygonCoordinates = polygon
                    .getCoordinates()[0]
                    .map((coord) => {
                    // Convertir cada coordenada de proyectadas a latitud y longitud (EPSG:3857 a EPSG:4326)
                    const lonLatCoord = (0, proj_1.transform)(coord, 'EPSG:3857', 'EPSG:4326');
                    return lonLatCoord.join(' ');
                })
                    .join(',');
                const polygonWKT = `POLYGON((${polygonCoordinates}))`;
                this.fieldsWithSamples.push({
                    polygon: polygonWKT,
                    points: pointCodes, // Almacenar los códigos de los puntos
                });
                const averageLevel = count > 1 ? totalLevel / count : totalLevel;
                var format = new WKT_1.default();
                var wktRepresenation = format.writeGeometry(polygon, this.projections);
                polygonFeature.set('polygonInfo', {
                    count: count,
                    averageLevel: averageLevel,
                    points: pointsInterPolygon,
                    polygon: wktRepresenation,
                    name: 'Field' + ' #' + (index + 1), // to ignore the 0
                });
                const color = this.generateColor(averageLevel, false);
                const parcelFill = `${color}30`;
                const parcelStroke = color;
                polygonFeature.setStyle(this.polygonStyle(parcelFill, parcelStroke));
                polygonFeatures.push(polygonFeature);
            });
            const polygonSource = new Vector_2.default({
                features: polygonFeatures,
            });
            const polygonLayer = new Vector_1.default({
                source: polygonSource,
            });
            polygonLayer.set('id', 'polygon-layer');
            this.addLayer(polygonLayer);
            this.drawPoints(this.points, this.typeMetric === 'HLT');
        }
    }
    showRecommendations(value) {
        const layers = this.map.getLayers().getArray();
        const layersToDelete = layers.filter((layer) => layer.get('id') === 'recommendations-indicator-layer');
        layersToDelete.forEach((layer) => layer.setVisible(value));
    }
    addCircleOverlay(center, number, defaultVisibility) {
        const circleStyle = new Style_1.default({
            image: new style_1.Circle({
                radius: 18,
                fill: new Fill_1.default({
                    color: '#2a7346',
                }),
            }),
        });
        const textStyle = new Style_1.default({
            text: new style_1.Text({
                text: number.toString(),
                fill: new Fill_1.default({
                    color: 'white',
                }),
                font: 'bold 16px "Nunito Sans", sans-serif',
            }),
        });
        const circleFeature = new ol.Feature({
            geometry: center,
        });
        circleFeature.setStyle([circleStyle, textStyle]);
        let vectorLayer = this.map
            .getLayers()
            .getArray()
            .find((layer) => layer.get('id') === 'recommendations-indicator-layer');
        if (!vectorLayer) {
            vectorLayer = new Vector_1.default({
                source: new Vector_2.default({
                    features: [circleFeature],
                }),
            });
            vectorLayer.set('id', 'recommendations-indicator-layer');
            vectorLayer.setVisible(defaultVisibility);
            vectorLayer.setZIndex(100);
            this.map.addLayer(vectorLayer);
        }
        else {
            const source = vectorLayer.getSource();
            source.addFeature(circleFeature);
        }
        this.map.on('click', (event) => {
            const layers = this.map.getLayers().getArray();
            const feature = this.map.forEachFeatureAtPixel(event.pixel, (feature) => feature);
            let clickedOnOverlay = false;
            const geometry = new WKT_1.default().readGeometry(this.parcel, this.projections);
            const polygons = geometry.getPolygons();
            if (feature) {
                polygons.forEach((polygon, index) => {
                    if (polygon.intersectsCoordinate(feature.getGeometry().getCoordinates())) {
                        this.recommendationPolygonName = `${this.areaName} - Field ${index + 1}`;
                    }
                });
                const coordinates = feature.getGeometry().getCoordinates();
                // Filtra las capas para acelerar la búsqueda
                const recommendationLayer = this.map
                    .getLayers()
                    .getArray()
                    .find((layer) => {
                    return layer instanceof Vector_1.default && layer.get('id') === 'recommendations-indicator-layer';
                });
                if (recommendationLayer) {
                    const source = recommendationLayer.getSource();
                    if (source.getFeatures().includes(feature)) {
                        clickedOnOverlay = true;
                        // Si el tooltip ya está creado, solo cambia su posición
                        if (this.tooltip) {
                            document.getElementById('recommendation-map-tooltip').style.display = 'block';
                            this.tooltip.setPosition(coordinates);
                        }
                        else {
                            // Si no está creado, créalo y agrégalo al mapa
                            document.getElementById('recommendation-map-tooltip').style.display = 'block';
                            let tooltipElement = document.getElementById('recommendation-map-tooltip');
                            this.tooltip = new Overlay_1.default({
                                element: tooltipElement,
                                offset: [0, 0],
                                positioning: 'center-center',
                                stopEvent: true,
                            });
                            this.tooltip.setPosition(coordinates);
                            this.map.addOverlay(this.tooltip);
                        }
                    }
                }
            }
            // Oculta el tooltip si no se hizo clic en el overlay
            if (!clickedOnOverlay) {
                if (this.tooltip) {
                    this.tooltip.setPosition(undefined);
                }
            }
        });
    }
    getFields() {
        const geometry = new WKT_1.default().readGeometry(this.parcel, this.projections);
        const polygons = geometry.getPolygons();
        this.fieldsWithSamples = [];
        polygons.forEach((polygon, index) => {
            const pointsInterPolygon = [];
            let countRecommendations = 0;
            const polygonFeature = new ol.Feature(polygon);
            this.points.forEach((point) => {
                const coordinates = point.coordinates.split(' ');
                const lon = parseFloat(coordinates[0].substring(6));
                const lat = parseFloat(coordinates[1].slice(0, -1));
                const newLon = lon;
                const newLat = lat;
                const POINT = (0, proj_1.fromLonLat)([newLon, newLat]);
                const pointGeometry = new Point_1.default(POINT);
                if (polygon.intersectsExtent(pointGeometry.getExtent())) {
                    pointsInterPolygon.push(point);
                    if (point.info.hasRecommendation) {
                        countRecommendations++;
                    }
                }
            });
            const pointCodes = pointsInterPolygon.map((point) => point.info.code);
            const polygonCoordinates = polygon
                .getCoordinates()[0]
                .map((coord) => {
                // Convertir cada coordenada de proyectadas a latitud y longitud (EPSG:3857 a EPSG:4326)
                const lonLatCoord = (0, proj_1.transform)(coord, 'EPSG:3857', 'EPSG:4326');
                return lonLatCoord.join(' ');
            })
                .join(',');
            const polygonCenter = polygon.getInteriorPoint();
            /* if (countRecommendations > 0) {
                    this.addCircleOverlay(polygonCenter, countRecommendations);
                } */
            // Construir la cadena WKT con las coordenadas de latitud y longitud
            const polygonWKT = `POLYGON((${polygonCoordinates}))`;
            polygonFeature.set('polygonName', `${this.areaName} - Field ${index}`);
            this.fieldsWithSamples.push({
                polygon: polygonWKT,
                points: pointCodes, // Almacenar los códigos de los puntos
            });
        });
    }
    generateRecomendationsIndicator(polygon, number) {
        const geometry = new WKT_1.default().readGeometry(polygon, this.projections);
        const center = (0, extent_1.getCenter)(geometry.getExtent());
        this.addCircleOverlay(new Point_1.default(center), number, true);
    }
    updateFieldNumber(polygon, number) {
        const geometry = new WKT_1.default().readGeometry(this.parcel, this.projections);
        const polygons = geometry.getPolygons();
        polygons.forEach((polygonInner, index) => {
            const polygonCoordinates = polygonInner
                .getCoordinates()[0]
                .map((coord) => {
                // Convertir cada coordenada de proyectadas a latitud y longitud (EPSG:3857 a EPSG:4326)
                const lonLatCoord = (0, proj_1.transform)(coord, 'EPSG:3857', 'EPSG:4326');
                return lonLatCoord.join(' ');
            })
                .join(',');
            const polygonWKT = `POLYGON((${polygonCoordinates}))`;
            const polygonCenter = polygonInner.getInteriorPoint();
            if (polygonWKT === polygon && number > 0) {
                this.addCircleOverlay(polygonCenter, number, false);
            }
        });
    }
    get getFieldsWithSamples() {
        return this.fieldsWithSamples;
    }
    onGeotiffLoaded() {
        this.deleteLayer('tiff-layer');
        const source = new GeoTIFF_1.default({
            sources: [
                {
                    // url: '/images/ZIN.tif',
                    url: this.tiff,
                    nodata: 255,
                    max: 100,
                    min: 0,
                },
            ],
        });
        const layer = new WebGLTile_js_1.default({
            source: source,
            visible: true,
            style: {
                color: [
                    'interpolate',
                    ['linear'],
                    ['band', 1],
                    0,
                    [0, 0, 0, 0],
                    0.000001,
                    this.generateColorRank(1, this.typeMetric === 'HLT'),
                    0.2,
                    this.generateColorRank(2, this.typeMetric === 'HLT'),
                    0.4,
                    this.generateColorRank(3, this.typeMetric === 'HLT'),
                    0.6,
                    this.generateColorRank(4, this.typeMetric === 'HLT'),
                    0.8,
                    this.generateColorRank(5, this.typeMetric === 'HLT'),
                    1,
                    this.typeMetric === 'HLT' ? [255, 0, 0] : [0, 0, 255],
                ],
            },
        });
        layer.set('id', 'tiff-layer');
        layer.setZIndex(1);
        this.map.addLayer(layer);
    }
    updateZooms(min) {
        this.map.getView().setMinZoom(min);
    }
    async onGeotiffLoadedT(url, resolution, name, center = true) {
        if (resolution === 'hight') {
            this.deleteLayer('eBecrop-layer');
        }
        let source;
        if (url.length > 0) {
            source = new GeoTIFF_1.default({
                sources: [
                    {
                        url: url,
                        nodata: 255,
                        max: 3,
                        min: 0,
                    },
                ],
                interpolate: false,
            });
        }
        else {
            source = new GeoTIFF_1.default({
                sources: [
                    {
                        url: '',
                        nodata: 255,
                        max: 3,
                        min: 0,
                    },
                ],
                interpolate: false,
            });
        }
        const layer = new WebGLTile_js_1.default({
            source: source,
            visible: true,
            cacheSize: 200,
            preload: 3,
            style: {
                color: [
                    'interpolate',
                    ['linear'],
                    ['band', 1],
                    0,
                    [0, 0, 0, 0],
                    0.00001,
                    '#E52721',
                    0.49,
                    '#E52721',
                    0.49999,
                    '#FF9A51',
                    0.5,
                    '#FF9A51',
                    1,
                    '#E6D581',
                ],
            },
        });
        layer.set('id', 'eBecrop-layer');
        layer.setZIndex(1);
        this.map.addLayer(layer);
        const f = await source.getView();
        const extent = f.extent;
        var extentInProjection = (0, proj_1.transformExtent)(extent, 'EPSG:4326', 'EPSG:3857');
        if (resolution === 'low') {
            //this.center('', extentInProjection);
            this.lowResolutionExtent.push(extentInProjection);
            this.statesRaterNames.push(name);
        }
        else {
            if (center) {
                this.center('', extentInProjection, true);
            }
        }
    }
    centerLow() {
        const handler = {};
        // Crear el proxy del arraygetFields
        const extentArray = this.lowResolutionExtent;
        var minX = extentArray[0][0];
        var minY = extentArray[0][1];
        var maxX = extentArray[0][2];
        var maxY = extentArray[0][3];
        for (var i = 1; i < extentArray.length; i++) {
            minX = Math.min(minX, extentArray[i][0]);
            minY = Math.min(minY, extentArray[i][1]);
            maxX = Math.max(maxX, extentArray[i][2]);
            maxY = Math.max(maxY, extentArray[i][3]);
        }
        var extent = [minX, minY, maxX, maxY];
        this.center('', extent, true);
    }
    deleteDrawInteraction() {
        this.drawInteraction.setActive(false);
        this.modifyInteraction.setActive(false);
    }
    async setEBecropStyle(value) {
        const layers = this.map.getLayers().getArray();
        const eBecropLayers = layers.filter((layer) => layer.get('id') === 'eBecrop-layer');
        for (const eBecropLayer of eBecropLayers) {
            const ff = await eBecropLayer.getSource().getView();
            if (value === 'low') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E6D58100',
                        0.49,
                        '#E6D58100',
                        0.49999,
                        '#FF9A5100',
                        0.5,
                        '#FF9A5100',
                        0.99,
                        '#FF9A5100',
                        1,
                        '#E6D581',
                    ],
                });
            }
            else if (value === 'medium') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E6D58100',
                        0.49,
                        '#E6D58100',
                        0.49999,
                        '#FF9A51',
                        0.5,
                        '#FF9A51',
                        0.99,
                        '#FF9A51',
                        1,
                        '#E5272100',
                    ],
                });
            }
            else if (value === 'hight') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E52721',
                        0.49,
                        '#E52721',
                        0.49999,
                        '#FF9A5100',
                        0.5,
                        '#FF9A5100',
                        0.99,
                        '#FF9A5100',
                        1,
                        '#E5272100',
                    ],
                });
            }
            else if (value === 'all') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E52721',
                        0.49,
                        '#E52721',
                        0.49999,
                        '#FF9A51',
                        0.5,
                        '#FF9A51',
                        0.99,
                        '#FF9A51',
                        1,
                        '#E6D581',
                    ],
                });
            }
            else if (value === 'none') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E47C7900',
                        0.49,
                        '#E47C7900',
                        0.5,
                        '#E6D58100',
                        0.99,
                        '#E6D58100',
                        1,
                        '#67BF3E00',
                    ],
                });
            }
        }
    }
    setOpacityEBecropLayer(opacity) {
        const transformOpacity = opacity / 100;
        const layers = this.map.getLayers().getArray();
        const eBecropLayers = layers.filter((layer) => layer.get('id') === 'eBecrop-layer');
        for (const eBecropLayer of eBecropLayers) {
            eBecropLayer.setOpacity(transformOpacity);
        }
    }
    async removePolygonDraw() {
        const layers = this.map.getLayers().getArray();
        const eBecropLayer = layers.find((layer) => layer.get('id') === 'eBecrop-layer');
        const ff = await eBecropLayer.getSource().getView();
        const extentz = ff.extent;
        var extentInProjectionz = (0, proj_1.transformExtent)(extentz, 'EPSG:4326', 'EPSG:3857');
        this.center('', extentInProjectionz, false);
        const eBecroplayer = layers.find((layer) => layer.get('id') === 'eBecrop-layer');
        const f = await eBecroplayer.getSource().getView();
        const extent = f.extent;
        var extentInProjection = (0, proj_1.transformExtent)(extent, 'EPSG:4326', 'EPSG:3857');
        this.center('', extentInProjection, true);
        this.drawInteraction.setActive(false);
        this.modifyInteraction.setActive(false);
        this.deleteLayer('base-layer');
        this.deleteLayer('draw-polygon-layer');
        this.deleteLayer('draw-points-layer');
        this.deleteLayer('draw-basecopy-layer');
        const baseLayerClear = this.mapLayer.layers[0];
        baseLayerClear.setZIndex(0);
        baseLayerClear.set('id', 'base-layer');
        this.map.addLayer(baseLayerClear);
    }
    applyCut() {
        //this.map.getViewport().style.cursor = 'auto';
        const baseLayerCopy = this.mapLayer.layers[0];
        const layers = this.map.getLayers().getArray();
        const baselayer = layers.find((layer) => layer.get('id') === 'base-layer');
        const polygonLayer = layers.find((layer) => layer.get('id') === 'draw-polygon-layer');
        const endStyles2 = new StylesGenerator_1.default().drawStyles.endStyleStep2;
        polygonLayer.setStyle(endStyles2);
        const polygonSource = polygonLayer.getSource();
        const featureP = polygonSource.getFeatures()[0];
        baseLayerCopy.set('id', 'draw-basecopy-layer');
        this.map.addLayer(baseLayerCopy);
        baseLayerCopy.setZIndex(2);
        const clipSource = new Vector_2.default({ features: [featureP] });
        const clipLayer = new Vector_1.default({ source: clipSource });
        const style = new Style_1.default({ fill: new Fill_1.default({ color: 'black' }) });
        baseLayerCopy.on('postrender', function (e) {
            const vectorContext = (0, render_1.getVectorContext)(e);
            e.context.globalCompositeOperation = 'destination-out';
            clipLayer.getSource().forEachFeature(function (feature) {
                vectorContext.drawFeature(feature, style);
            });
            e.context.globalCompositeOperation = 'source-over';
        });
        setTimeout(() => {
            baselayer.on('postrender', function (e) {
                const vectorContext = (0, render_1.getVectorContext)(e);
                e.context.globalCompositeOperation = 'destination-in';
                clipLayer.getSource().forEachFeature(function (feature) {
                    vectorContext.drawFeature(feature, style);
                });
                e.context.globalCompositeOperation = 'source-over';
            });
            this.center('', clipSource.getExtent(), true);
        }, 100);
    }
    async addDrawInteraction() {
        const layers = this.map.getLayers().getArray();
        const eBecropLayer = layers.find((layer) => layer.get('id') === 'eBecrop-layer');
        const ff = await eBecropLayer.getSource().getView();
        const extentz = ff.extent;
        var extentInProjectionz = (0, proj_1.transformExtent)(extentz, 'EPSG:4326', 'EPSG:3857');
        //this.center('', extentInProjectionz, true);
        this.deleteLayer('base-layer');
        this.deleteLayer('draw-polygon-layer');
        this.deleteLayer('draw-points-layer');
        this.deleteLayer('draw-basecopy-layer');
        this.finishDrawInteraction = false;
        const baseLayerClear = this.mapLayer.layers[0];
        baseLayerClear.setZIndex(0);
        baseLayerClear.set('id', 'base-layer');
        this.map.addLayer(baseLayerClear);
        const map = this.map;
        const drawStyles = new StylesGenerator_1.default().drawStyles;
        const polygonSource = new Vector_2.default();
        const polygonLayer = new Vector_1.default({ source: polygonSource });
        const pointsSource = new Vector_2.default();
        const pointsLayer = new Vector_1.default({
            source: pointsSource,
            style: new Style_1.default({ image: drawStyles.pointsStyle }),
        });
        const drawInteraction = new Draw_js_1.default({
            source: polygonSource,
            type: 'Polygon',
            style: drawStyles.drawingStyle,
        });
        this.drawInteraction = drawInteraction;
        polygonLayer.set('id', 'draw-polygon-layer');
        polygonLayer.setZIndex(3);
        map.addLayer(polygonLayer);
        pointsLayer.setZIndex(3);
        pointsLayer.set('id', 'draw-points-layer');
        map.addLayer(pointsLayer);
        map.addInteraction(drawInteraction);
        const modifyInteraction = new Modify_js_1.default({
            source: polygonSource,
            style: new Style_1.default({ image: drawStyles.pointsStyle }),
        });
        this.modifyInteraction = modifyInteraction;
        map.addInteraction(modifyInteraction);
        const addPointsToLayer = (coordinates) => {
            pointsSource.clear(); // Limpiar puntos existentes
            coordinates.forEach((coordinate) => {
                const puntoFeature = new ol.Feature(new Point_1.default(coordinate));
                pointsSource.addFeature(puntoFeature);
            });
        };
        modifyInteraction.on('modifyend', (event) => {
            const feature = event.features.item(0); // El primer polígono modificado
            if (feature) {
                const geometry = feature.getGeometry();
                const coordinates = geometry.getCoordinates()[0];
                addPointsToLayer(coordinates); // Agrega los puntos actualizados
            }
        });
        modifyInteraction.on('modifystart', (event) => {
            const feature = event.features.item(0); // El primer polígono modificado
            if (feature) {
                const geometry = feature.getGeometry();
                const coordinates = geometry.getCoordinates()[0];
                coordinates.forEach((coordinate) => {
                    const puntoFeature = pointsSource.getClosestFeatureToCoordinate(coordinate);
                    if (puntoFeature) {
                        pointsSource.removeFeature(puntoFeature);
                    }
                });
            }
            //map.getViewport().style.cursor = 'url("/images/pencil_map.svg"), auto';
        });
        drawInteraction.on('drawend', async (event) => {
            this.finishDrawInteraction = false;
            const feature = event.feature;
            feature.setStyle(drawStyles.endStyle);
            const geometry = feature.getGeometry();
            const coordinates = geometry.getCoordinates()[0];
            coordinates.forEach((coordinate) => {
                const puntoFeature = new ol.Feature(new Point_1.default(coordinate));
                pointsSource.addFeature(puntoFeature);
            });
            drawInteraction.setActive(false);
            this.finishDrawInteraction = true;
        });
        /* drawInteraction.on('drawstart', async (event) => {
            map.getViewport().style.cursor = 'url("/images/pencil_map.svg"), auto';
        }); */
    }
    get drawPolygonData() {
        const layers = this.map.getLayers().getArray();
        const polygonLayer = layers.find((layer) => layer.get('id') === 'draw-polygon-layer');
        if (polygonLayer && polygonLayer.getSource().getFeatures().length) {
            const feature = polygonLayer.getSource().getFeatures()[0];
            const geometry = feature.getGeometry();
            const geometryExtent = geometry.getExtent();
            const center = (0, extent_1.getCenter)(geometryExtent);
            const area = olSphere.getArea(geometry);
            const hectares = area / 10000;
            const transformedCoordinates = geometry
                .getCoordinates()
                .map((ring) => ring.map((coord) => (0, proj_1.transform)(coord, 'EPSG:3857', 'EPSG:4326')));
            const geodata = `POLYGON(${transformedCoordinates
                .map((ring) => `(${ring.map((coord) => coord.join(' ')).join(',')})`)
                .join(', ')})`;
            return {
                coordinates: center,
                hectares: hectares,
                geodata: geodata,
            };
        }
        else {
            return {
                coordinates: [],
                hectares: 0,
                geodata: '',
            };
        }
    }
    async centrarMapaEnUbicacion(location) {
        const locationCap = location.charAt(0).toUpperCase() + location.slice(1);
        let statesExtents = {};
        this.loadingSearchZone = true;
        this.intersectingExtentIndices = [];
        for (var i = 0; i < this.statesRaterNames.length; i++) {
            var name = this.statesRaterNames[i];
            var value = this.lowResolutionExtent[i];
            statesExtents[name] = value;
        }
        if (this.statesRaterNames.includes(locationCap)) {
            this.map.on('loadend', () => {
                this.loadingSearchZone = false;
            });
            this.isErrorSearchZone = false;
            this.regionSearch = locationCap;
            this.intersectingExtentIndices.push(locationCap);
            this.center('', statesExtents[locationCap], true);
        }
        else {
            this.loadingSearchZone = false;
            this.isErrorSearchZone = true;
            this.errorMenssage = (0, trans_1.trans)('e_becrop.search_bar.not_result');
        }
    }
    updateMessageErrorSearch() {
        this.loadingSearchZone = false;
        this.isErrorSearchZone = false;
        this.errorMenssage = '';
    }
}
exports.default = MapBmkController;
